import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`I am a developer by profession (and luckily by hobby as well!). `}</p>
    </blockquote>
    <p>{`I have been working as a freelancer since March 2018 and its been a great experience so far. I have worked with clients from US, UK, Canada, Netherlands, France and many more countries. I have developed a lot of interesting products ranging from small automation scripts to large scale mobile apps and websites taking advantage of full potiential of AWS Cloud technologies and facial recognition systems. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      